<template>
    <div>
        <ClinicalHistorySection class="mb-2" />
        <Immunization class="mb-2" />
        <ImplantableDeviceSection />
    </div>
</template>

<script lang="ts" src="./HealthHistory.ts" />
